<template>
  <div class="register-container">
    <div class="register-box">
      <h2 class="register-title">用户注册</h2>
      <a-form
        class="register-form"
        @submit="handleSubmit"
      >
        <a-form-item>
          <a-input
            v-model="phone"
            placeholder="手机号"
            size="large"
            :maxLength="11"
            @input="handlePhoneInput"
          >
            <a-icon slot="prefix" type="mobile" style="color: rgba(0,0,0,.25)" />
          </a-input>
        </a-form-item>
        <a-form-item>
          <a-input
            v-model="password"
            type="password"
            placeholder="密码"
            size="large"
          >
            <a-icon slot="prefix" type="lock" style="color: rgba(0,0,0,.25)" />
          </a-input>
        </a-form-item>
        <a-form-item>
          <a-input
            v-model="confirmPassword"
            type="password"
            placeholder="确认密码"
            size="large"
          >
            <a-icon slot="prefix" type="lock" style="color: rgba(0,0,0,.25)" />
          </a-input>
        </a-form-item>
        <a-form-item>
          <a-button
            type="primary"
            html-type="submit"
            class="register-button"
            size="large"
            :loading="loading"
          >
            注册
          </a-button>
        </a-form-item>
        <a-form-item style="margin-bottom: 0;">
          <div class="register-footer">
            <a-button type="link" @click="goToLogin">已有账号？去登录</a-button>
          </div>
        </a-form-item>
      </a-form>
    </div>
  </div>
</template>

<script>
import api from '../api'

export default {
  name: 'Register',
  data () {
    return {
      phone: '',
      password: '',
      confirmPassword: '',
      loading: false
    }
  },
  methods: {
    handlePhoneInput (e) {
      // 只允许输入数字
      this.phone = e.target.value.replace(/\D/g, '')
    },
    validatePhone (phone) {
      // 验证手机号格式（11位数字，1开头）
      const phoneRegex = /^1[3-9]\d{9}$/
      return phoneRegex.test(phone)
    },
    async handleSubmit (e) {
      e.preventDefault()
      
      // 验证手机号
      if (!this.phone) {
        this.$message.warning('请输入手机号！')
        return
      }
      
      if (!this.validatePhone(this.phone)) {
        this.$message.warning('请输入正确的手机号格式！')
        return
      }
      
      // 验证密码
      if (!this.password) {
        this.$message.warning('请输入密码！')
        return
      }
      
      if (this.password.length < 6) {
        this.$message.warning('密码长度至少6位！')
        return
      }
      
      if (this.password !== this.confirmPassword) {
        this.$message.warning('两次输入的密码不一致！')
        return
      }
      
      this.loading = true
      
      try {
        const response = await api.register({
          phone: this.phone,
          password: this.password
        })
        
        if (response.success) {
          this.$message.success('注册成功！请等待管理员审批后即可登录使用')
          
          // 延迟跳转到登录页
          setTimeout(() => {
            this.$router.push('/login')
          }, 2000)
        }
      } catch (error) {
        this.$message.error(error.message || '注册失败，请重试')
      } finally {
        this.loading = false
      }
    },
    goToLogin () {
      this.$router.push('/login')
    }
  },
  mounted () {
    // 如果已经登录，直接跳转
    if (this.$store.state.isLoggedIn) {
      const currentUser = this.$store.state.currentUser
      if (currentUser && currentUser.role === 'admin') {
        this.$router.push('/admin')
      } else {
        this.$router.push('/')
      }
    }
  }
}
</script>

<style scoped>
.register-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.register-box {
  width: 400px;
  padding: 40px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.register-title {
  text-align: center;
  margin-bottom: 30px;
  font-size: 28px;
  font-weight: 600;
  color: #333;
}

.register-form {
  width: 100%;
}

.register-button {
  width: 100%;
  height: 40px;
  font-size: 16px;
}

.register-footer {
  text-align: center;
  width: 100%;
}
</style>

